export default "__VITE_ASSET__BUdHSisV__"